import { AfterViewInit, Component, ElementRef, Input, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';

interface SearchError {
  NO_COVERAGE: 'NO_COVERAGE';
  NO_PROPERTY: 'NO_PROPERTY';
  HIGH_PROPERTY_COUNT: 'HIGH_PROPERTY_COUNT';
  ZOOM_LIMIT_REACHED: 'ZOOM_LIMIT_REACHED';
  INTERNAL_ERROR: 'INTERNAL_ERROR';
}

@Component({
  selector: 'app-property-search-error',
  templateUrl: './property-search-error.component.html',
  styleUrls: ['./property-search-error.component.scss'],
})
export class ZoomLimitComponent implements AfterViewInit, OnDestroy {
  constructor(public appState: AppState, private renderer: Renderer2) {}
  @Input('type') errorType: keyof SearchError;
  @ViewChild('errorContainer') errorContainer: ElementRef;
  companyInfo: any = {};

  // Subscriptions to unsubscribe on component destroy
  onDestroyNotifier$ = new Subject();

  ngAfterViewInit(): void {
    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res && Object.keys(res).length) {
        this.companyInfo = res;

        let errorHtml = '';
        switch (this.errorType) {
          case 'HIGH_PROPERTY_COUNT':
            errorHtml = res?.geoCoverageConfig?.highPropertyCountMessage;
            break;

          case 'ZOOM_LIMIT_REACHED':
            errorHtml = res?.geoCoverageConfig?.zoomLimitMessage;
            break;

          case 'NO_PROPERTY':
            errorHtml = res?.geoCoverageConfig?.noPropertyMessage;
            break;

          default:
            break;
        }

        this.renderer.setProperty(this.errorContainer.nativeElement, 'innerHTML', errorHtml);
      }
    });
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
